import AddUpdateModal from 'components/Analytics/AddUpdateModal';
import { RaisedButton } from 'material-ui';
import React, { useState } from 'react';

export default function SaveLink() {
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <span style={{ display: 'inline-block', marginLeft: '10px' }}>
            <AddUpdateModal 
                open={openDialog}
                setOpen={setOpenDialog}
                type='add'
                fromLetter
            />

            <RaisedButton 
                className='btn'
                labelStyle={{ fontSize: '10px', color: 'white' }}
                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                buttonStyle={{ height: '25px', lineHeight: '25px', backgroundColor: '#B26E63' }}
                label='Dashboard'
                onClick={() => setOpenDialog(!openDialog)}
            />
        </span>
    );
}



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/SaveLink.jsx